import styled from "styled-components";

const Textarea = styled.textarea`
  appearance: none;
  border-radius: 12px;
  border: 1px solid #e6e6e6;
  padding: .75rem;
  transition: .1s;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  font-weight: 600;
  font-size: 1.1rem;
  &:hover {
    border: 1px solid #d2d2d2;
  }
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #c8c8c8;
  }
`;

export default Textarea;